<template>
  <v-card class="pa-4 elevation-0 rounded-xl h-100-pct hover-shadow ">
    <div class="font-size-12 cl-grey font-weight-500 mb-2">New Members</div>
    <template v-if="tenNewDownlineList">
      <template v-if="tenNewDownlineList.length > 6">
        <carousel v-bind="slideSetting" id="memberSlide" :style="{height: '350px', overflow: 'hidden'}">
          <v-row class="py-2" v-for="downline in tenNewDownlineList" :key="downline.member_id">
            <v-col cols="12" sm="12" md="12" class="d-flex align-start py-2">
              <!-- <v-icon color="grey">mdi-account-circle-outline</v-icon> -->
              <v-col><v-img :src="downline.member_country_flag" cover width="20px"></v-img></v-col>
              <v-col cols="12" sm="7" md="7" class="pa-1">
                <div class="font-size-11 cl-grey text-capitalize "><div v-html="$options.filters.longText(downline.member_name, 17)"></div></div>
                <div class="font-size-11 cl-primary font-weight-500">{{ downline.member_network_code }}</div>
              </v-col>
              <v-col cols="12" sm="2" md="2" class="py-0 d-flex align-center justify-center">
                <div class="font-size-11 cl-grey">{{ (downline.member_position == 'Kiri') ? 'Left' : 'Right' }}</div>
              </v-col>
              <v-col cols="12" sm="3" md="3" class="py-0 d-flex align-center justify-end text-md-right">
                <div class="font-size-11 cl-grey">{{ downline.member_netgrow_node_date | toDate }}</div>
              </v-col>
            </v-col>
          </v-row>
        </carousel>
      </template>
      <template v-else>
        <v-row class="mt-2" v-for="downline in tenNewDownlineList" :key="downline.netgrow_node_id">
          <v-col cols="12" sm="7" md="7" class="py-0 d-flex align-start">
            <!-- <v-icon color="grey">mdi-account-circle-outline</v-icon> -->
            <v-col cols="2"><v-img :src="downline.member_country_flag" cover width="20px"></v-img></v-col>
            <v-col class="py-1">
              <div class="font-size-11 cl-grey text-capitalize "><div v-html="$options.filters.longText(downline.member_name, 17)"></div></div>
              <div class="font-size-11 cl-primary font-weight-500">{{ downline.member_network_code }}</div>
            </v-col>
          </v-col>
          <v-col cols="12" sm="2" md="2" class="py-0  d-flex align-center justify-center">
            <div class="font-size-11 cl-grey">{{ (downline.member_position == 'Kiri') ? 'Left' : 'Right' }}</div>
          </v-col>
          <v-col cols="12" sm="3" md="3" class="py-0 d-flex align-center justify-end text-md-right">
            <div class="font-size-11 cl-grey">{{ downline.member_netgrow_node_date | toDate }}</div>
          </v-col>
        </v-row>
      </template>
    </template>
    <template v-else>
      <div class="d-flex flex-column fill-height align-center justify-center pa-5">
        <v-icon color="grey" large>mdi-information-outline</v-icon>
        <div class="font-size-10 mt-4 text-center cl-grey">No member data available.</div>
      </div>
    </template>
    <!-- <v-row>
      <v-col cols="12">
        <div class="font-size-12 cl-grey font-weight-500">Data Mitra Terbaru</div>
      </v-col>
    </v-row>
    <template v-if="tenNewDownlineList.length > 0">
      <v-row v-for="downline in tenNewDownlineList" :key="downline.netgrow_node_id">
        <v-col cols="12" sm="12" md="8" class="d-flex align-center pb-0">
          <v-icon color="grey">mdi-account-circle-outline</v-icon>
          <v-col>
            <div class="font-size-11 cl-grey text-capitalize ml-1"><div v-html="$options.filters.longText(downline.member_name, 17)"></div></div>
            <div class="font-size-11 cl-primary font-weight-500">{{ downline.member_network_code }}</div>
          </v-col>
        </v-col>
        <v-col cols="12" sm="12" md="4" class="pt-0 pb-0 pt-sm-3 d-flex align-center justify-end text-md-right">
          <div class="font-size-11 cl-grey">{{ downline.member_netgrow_node_date | toDate }}</div>
        </v-col>
      </v-row>
    </template>
    <template v-else>
      <div class="d-flex flex-column fill-height align-center justify-center pa-5">
        <v-icon color="grey" large>mdi-information-outline</v-icon>
        <div class="font-size-10 mt-4 text-center cl-grey">Belum ada data daftar downline yang ditampilkan.</div>
      </div>
    </template>
    <div class="pb-3"></div> -->
  </v-card>
</template>

<script>
import carousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

export default {
  data() {
    return {
    }
  },
  components: {
    carousel
  },
  props: {
    tenNewDownlineList: Array,
    slideSetting: Object
  }
}
</script>